import React, { useEffect, useState } from 'react';

// Mostra o placeholder (thumb/preview local) na hora e troca pela imagem final assim que ela terminar de carregar.
export const SmartImg = ({ src, placeholder, ...props }) => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setReady(false);
    if (!src) return undefined;
    const im = new Image();
    im.onload = () => setReady(true);
    im.src = src;
    return () => { im.onload = null; };
  }, [src]);
  return <img src={ready || !placeholder ? src : placeholder} {...props} />;
};
